// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-image-source-wrapper{position:relative;display:inline-block;margin:1rem 0}.czt-image-source-wrapper>img{margin:0}", ""]);
// Exports
module.exports = exports;
